const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5056/api').replace(/\/$/, '');

async function request(path, { method = 'GET', body, token, query } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const qs = query
    ? '?' + Object.entries(query)
        .filter(([_, v]) => v !== undefined && v !== '')
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&')
    : '';
  const res = await fetch(`${API_BASE}${path}${qs}`, {
    method, headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error?.message || `HTTP ${res.status}`);
    err.code   = data?.error?.code || `HTTP_${res.status}`;
    err.status = res.status;
    throw err;
  }
  return data;
}

// Deux sous-objets pour ne pas confondre les deux entités.
export const sitesApi = {
  list:        (opts)         => request('/tourisme/sites',             { query: opts }),
  get:         (idOrSlug)     => request(`/tourisme/sites/${idOrSlug}`),
  adminList:   (token, opts)  => request('/admin/tourisme/sites',       { token, query: opts }),
  adminGet:    (token, id)    => request(`/admin/tourisme/sites/${id}`, { token }),
  adminCreate: (token, body)  => request('/admin/tourisme/sites',       { method: 'POST',   token, body }),
  adminUpdate: (token, id, b) => request(`/admin/tourisme/sites/${id}`, { method: 'PATCH',  token, body: b }),
  adminDelete: (token, id)    => request(`/admin/tourisme/sites/${id}`, { method: 'DELETE', token }),
};

export const circuitsApi = {
  list:        (opts)         => request('/tourisme/circuits',             { query: opts }),
  get:         (idOrSlug)     => request(`/tourisme/circuits/${idOrSlug}`),
  adminList:   (token, opts)  => request('/admin/tourisme/circuits',       { token, query: opts }),
  adminGet:    (token, id)    => request(`/admin/tourisme/circuits/${id}`, { token }),
  adminCreate: (token, body)  => request('/admin/tourisme/circuits',       { method: 'POST',   token, body }),
  adminUpdate: (token, id, b) => request(`/admin/tourisme/circuits/${id}`, { method: 'PATCH',  token, body: b }),
  adminDelete: (token, id)    => request(`/admin/tourisme/circuits/${id}`, { method: 'DELETE', token }),
};

export const SITE_CATEGORIES = [
  { id: 'all',         lbl: 'Toutes catégories' },
  { id: 'religieux',   lbl: 'Religieux' },
  { id: 'culturel',    lbl: 'Culturel' },
  { id: 'nature',      lbl: 'Nature' },
  { id: 'patrimoine',  lbl: 'Patrimoine' },
  { id: 'gastronomie', lbl: 'Gastronomie' },
];

export const DIFFICULTIES = [
  { id: 'all',       lbl: 'Toutes' },
  { id: 'facile',    lbl: 'Facile' },
  { id: 'modere',    lbl: 'Modéré' },
  { id: 'difficile', lbl: 'Difficile' },
];

export const CAT_LABEL  = Object.fromEntries(SITE_CATEGORIES.map((c) => [c.id, c.lbl]));
export const DIFF_LABEL = Object.fromEntries(DIFFICULTIES.map((d) => [d.id, d.lbl]));
